<template>
  <div class="animated fadeIn" id="list-mail">
    <transition name="fade">
      <b-card no-body>
        <div slot="header">
          <i class="fa fa-search mr-2"></i>
          <strong>Recherche</strong>
          <div class="card-header-actions">
            <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
              <span class="when-opened">
                <i class="icon-arrow-down"></i>
              </span>
              <span class="when-closed">
                <i class="icon-arrow-up"></i>
              </span>
            </b-link>
          </div>
        </div>
        <b-collapse id="collapse1" visible>
          <b-card-body>
            <b-card>
              <b-form v-on:submit.prevent="search">
                <b-row>
                  <b-col sm="5" class="borded-right">
                    <b-row class="mb-1">
                      <b-col sm="3">
                        <label for="date_du"><strong>Période du</strong></label>
                      </b-col>
                      <b-col sm="4">
                        <b-form-input type="date" id="date_du" v-model="dateDu" :class="{hasError: errors.dateDu !== '', input_date : true}"></b-form-input>
                        <span class="field-error">{{ errors.dateDu }}</span>
                      </b-col>
                      <b-col sm="1">
                        <label for="date_au"><strong>Au</strong></label>
                      </b-col>
                      <b-col sm="4">
                        <b-form-input type="date" id="date_au" v-model="dateAu" :class="{hasError: errors.dateAu !== '', input_date : true}"></b-form-input>
                        <span class="field-error">{{ errors.dateAu }}</span>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col sm="3">
                        <label for="from"><strong>De : </strong></label>
                      </b-col>
                      <b-col sm="9">
                          <b-form-input type="text" id="from" v-model="from" placeholder="Contient..."></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col sm="3">
                        <label for="nir"><strong>NIR</strong></label>
                      </b-col>
                      <b-col sm="9">
                          <b-form-input type="text" id="nir" v-model="nir" placeholder="Commence par..."></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col sm="3">
                        <label for="text"><strong>Texte : </strong></label>
                      </b-col>
                      <b-col sm="9">
                          <b-form-input type="text" id="text" v-model="text" placeholder="Contient..."></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col sm="3">
                        <label for="mailId"><strong>N° du mail</strong></label>
                      </b-col>
                      <b-col sm="9">
                          <b-form-input type="number" id="mailId" v-model="mailId" :class="{hasError: errors.mailId !== ''}"></b-form-input>
                          <span class="field-error">{{ errors.mailId }}</span>
                      </b-col>
                    </b-row>

                    <div slot="footer" class="mt-1 text-right">
                      <a v-if="canSeeSpam()" href="#" @click.prevent="showSpam" class="float-left">Voir les spams</a>
                      <b-button type="button" @click.prevent="clearForm()" size="md" variant="secondary" class="mr-1">
                        <i class="fa fa-eraser"></i> Effacer
                      </b-button>
                      <b-button type="enter" @click.prevent="search()" size="md" variant="primary">
                        <i class="fa fa-search"></i> Rechercher
                      </b-button>
                      <span class="field-error">{{ errors.critere }}</span>
                    </div>
                  </b-col>
                  <b-col sm="7">
                    <b-form-checkbox
                      v-model="allSelected"
                      :indeterminate="indeterminate"
                      aria-describedby="bals"
                      aria-controls="bals"
                      @change="toggleAll"
                    >
                      {{ allSelected ? 'Tout déselectionner' : 'Tout sélectionner' }}
                    </b-form-checkbox>
                    <span class="field-error">{{ errors.bals }}</span>
                    <b-row>
                      <b-col sm="4" v-for="(bals, key) in groupBals" :key="key">
                        <b-form-group>
                          <b-form-checkbox-group :id="`checkbox-group-${key}`" v-model="selectedBals" name="bals" stacked>
                            <b-form-checkbox v-for="(bal, key) in bals" :value="`${bal.id}`" :key="bal.id">{{ bal.nom }} <i class="text-info" v-if="getBalTotal(bal.id) > 0">({{ getBalTotal(bal.id) }})</i></b-form-checkbox>
                          </b-form-checkbox-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-form>
            </b-card>
          </b-card-body>
        </b-collapse>
      </b-card>
    </transition>

    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i>
        <strong>{{ searchSpam ? 'Liste des SPAM' : 'Liste des mails' }}</strong>
      </b-card-header>
      <b-card-body>
        <mail-table :tableEntry="tableParam" :searchSpam="searchSpam" ref="mail_table"></mail-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '@/utils/auth'
import { hasRule, espaceGestionRules as rules } from '@/utils/rulesHelper'
import {fr} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import MailTable from './MailTable'

export default {
  components: { MailTable },
  data() {
    return {
      from: "",
      mailId: "",
      nir: "",
      text: "",
      dateDu: "",
      dateAu: "",
      noSearch: "noSearch",
      searchSpam: false,
      selectedBals: [],
      groupBals: [],
      allBals:[],
      allSelected: false,
      indeterminate: false,
      resultStats: [],
      errors: { dateAu: '', dateDu: '', mailId: '', bals: '', critere: '', mailId: '' }
    }
  },
  mounted() {
    this.getBals()
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
    this.$axios.defaults.headers.common['Accept'] = 'application/json';
    this.$axios.defaults.headers.common['Provider'] = getProvider();

    let queries = this.$route.query
    if (this.$route.query.mf) {
      this.from = this.$route.query.mf
      delete queries.mf
    }
    if (this.$route.query.nir) {
      this.nir = this.$route.query.nir
      delete queries.nir
    }
    if (this.$route.query.mi) {
      this.mailId = this.$route.query.mi
      delete queries.mi
    }
    if (this.$route.query.text) {
      this.text = this.$route.query.text
      delete queries.text
    }
    if (this.$route.query.dd) {
      this.dateDu = this.$route.query.dd
      delete queries.dd
    }
    if (this.$route.query.da) {
      this.dateAu = this.$route.query.da
      delete queries.da
    }
    if (this.$route.query.ss) {
      this.searchSpam = this.$route.query.ss
      delete queries.ss
    }
    if (this.$route.query.bals) {
      this.selectedBals = this.$route.query.bals
      delete queries.bals
    }
    // Si on à this.$route.query.bals c'est qu'on revient d'une fiche et donc il y a eu une recherche , donc noSearch = ''
    if (this.$route.query.bals) {
      this.noSearch = ''
    }
    // this.$router.replace({ query: queries })
  },
  computed: {
    tableParam: {
      get() {
        let request = {};

        request.from = this.from
        request.mailId = this.mailId
        request.nir = this.nir.replace(/ /g, "")
        this.nir = request.nir
        request.text = this.text
        request.dateDu = this.dateDu
        request.dateAu = this.dateAu
        request.noSearch = this.noSearch
        request.searchSpam = this.searchSpam
        request.bals = this.selectedBals

        return request
      }
    },
  },
  watch: {
    selectedBals(newVal, oldVal) {
      // Handle changes in individual checkboxes
      if (newVal.length === 0) {
        this.indeterminate = false
        this.allSelected = false
      } else if (newVal.length === this.allBals.length) {
        this.indeterminate = false
        this.allSelected = true
      } else {
        this.indeterminate = true
        this.allSelected = false
      }
    }
  },
  methods: {
    toggleAll(checked) {
      this.selectedBals = checked ? this.allBals.map(bal => {return bal.id}) : []
    },
    getBals() {
      let self = this
      let dataPost = {
        'provider': getProvider()
      }
      this.$store.commit("IS_LOADING", true)
      this.$axios
        .post("/espaceGestion/mail/getBals", dataPost)
        .then(response => {
          this.$store.commit("IS_LOADING", false)
          // console.log(response)
          this.allBals = response.data.bals
          this.groupBals = _.chunk(Object.values(response.data.bals), 5)
          // Par défaut on sélectionne toutes les bals
          this.selectedBals = this.allBals.map(bal => {return bal.id})
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false)
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    search() {
      if (this.validateData()) {
        this.searchSpam = false
        this.noSearch = ""
        this.$refs.mail_table.$refs.table.refresh()
      }
    },
    showSpam() {
      this.searchSpam = true
      this.noSearch = ""
      this.$refs.mail_table.$refs.table.refresh()
    },
    canSeeSpam() {
      return hasRule(rules.MANAGE_NEUTRALISE_RECEPTION_MAIL)
    },
    validateData() {
      this.clearErrors()
      let valid = true

      if (this.selectedBals.length == 0) {
        this.errors.bals = 'Vous devez sélectionner au moins une boîte aux lettres.'
        valid = false
      }

      if (this.from === '' && this.mailId === '' && this.nir === '' && this.text === '' && this.dateDu === '' && this.dateAu === '') {
        this.errors.critere = 'Vous devez définir au moins un critère de recherche.'
        valid = false
      }

      if (this.mailId < 0) {
        this.errors.mailId = 'Le numéro de dossier ne peut être négatif.'
        valid = false
      }

      return valid;
    },
    getBalTotal(balId) {
      // let total = 0;
      let stat = this.resultStats.find(stat => stat.bal_id === parseInt(balId,10))
      // console.log('stat', stat)
      return stat !== undefined ? stat.total : 0;
    },
    clearForm() {
      this.from = ""
      this.mailId = ""
      this.nir = ""
      this.text = ""
      this.dateDu = ""
      this.dateAu = ""
      this.clearErrors()
    },
    clearErrors() {
      this.errors.dateDu = ''
      this.errors.dateAu = ''
      this.errors.bals = ''
      this.errors.critere = ''
      this.errors.mailId = ''
    }
  }
}
</script>
<style scoped>
  .borded-right {
    border-right: 1px solid #d5d5d5;
  }
  input.input_date:invalid {
    /*content: '✖';
    padding-left: 5px;*/
    border: solid 1px #ff1744;
  }
</style>
